import React, { useEffect, useState } from "react";
import T from "prop-types";
import api from "APP_ROOT/api";
import { withFieldAccessors } from "MODULES/shared/decorators/withFieldAccessors";
import { INVENTORY_ATTACHMENT_IDS } from "MODULES/OutgoingQuotes/constants";

function ImageOption({ attachment, attachmentField, getFieldValue, onSelect }) {
  const attachmentIds = getFieldValue(attachmentField) || [];
  const selected = attachmentIds.includes(attachment.id);

  return (
    <div
      style={{ position: "relative" }}
      onClick={() => onSelect(attachment)}
      className="clickable"
    >
      <img
        alt={attachment.name}
        src={attachment.small_file_url}
        style={{ height: "100px", paddingTop: "10px", paddingLeft: "10px" }}
      />
      {selected && (
        <span
          className="fa fa-check-circle"
          style={{
            position: "absolute",
            bottom: "5px",
            left: "15px",
            color: "#4CAF50"
          }}
        />
      )}
    </div>
  );
}

ImageOption.propTypes = {
  attachment: T.shape({}),
  attachmentField: T.string,
  getFieldValue: T.func.isRequired,
  onSelect: T.func.isRequired
};

function SelectImages({
  formSection,
  inventory,
  setFieldValue,
  getFieldValue
}) {
  if (!inventory) return null;
  const [attachments, setAttachments] = useState([]);

  const attachmentField = [formSection, INVENTORY_ATTACHMENT_IDS]
    .filter(f => f)
    .join(".");

  useEffect(
    () => {
      api.inventories.attachments.search(inventory.id).then(({ data }) => {
        setAttachments(data.results.filter(f => f.small_file_url));
        setFieldValue(attachmentField)([]);
      });

      return function cleanup() {};
    },
    [inventory && inventory.id]
  );

  const onSelect = attachment => {
    const attachmentIds = getFieldValue(attachmentField) || [];

    if (attachmentIds.includes(attachment.id)) {
      const index = attachmentIds.indexOf(attachment.id);
      attachmentIds.splice(index, 1);
      setFieldValue(attachmentField)(attachmentIds);
    } else {
      attachmentIds.push(attachment.id);
      setFieldValue(attachmentField)(attachmentIds);
    }
  };

  return (
    <React.Fragment>
      <hr style={{ margin: "20px 0" }} />
      <h4>Add Photo Attachments</h4>
      <div style={{ display: "flex", flexWrap: "wrap" }}>
        {attachments.map(attachment => (
          <ImageOption
            attachment={attachment}
            onSelect={onSelect}
            getFieldValue={getFieldValue}
            attachmentField={attachmentField}
          />
        ))}
      </div>
    </React.Fragment>
  );
}

SelectImages.propTypes = {
  formSection: T.string,
  inventory: T.shape({ id: T.number }),
  setFieldValue: T.func.isRequired,
  getFieldValue: T.func.isRequired
};

export default withFieldAccessors(SelectImages);



// WEBPACK FOOTER //
// ./app/modules/parts/components/Detail/OutgoingQuotes/SelectImages.jsx